module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pomodoro_circle_01.d5b7dec4.svg";